import { useEffect, useState } from 'react';

function getStandaloneMode() {
  if (typeof window === 'undefined') {
    return false;
  }

  const nav = window.navigator as Navigator & { standalone?: boolean };
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    nav.standalone === true
  );
}

export function useStandaloneMode() {
  const [isStandalone, setIsStandalone] = useState(getStandaloneMode);

  useEffect(() => {
    const media = window.matchMedia('(display-mode: standalone)');

    function updateStandaloneMode() {
      setIsStandalone(getStandaloneMode());
    }

    media.addEventListener('change', updateStandaloneMode);
    return () => media.removeEventListener('change', updateStandaloneMode);
  }, []);

  return isStandalone;
}

